import { z } from 'zod';

import { preferredLanguageSchema } from './language';
import { idSchema } from './utils';

export type ProjectUserPathParams = z.infer<typeof projectUserPathParamsSchema>;
export const projectUserPathParamsSchema = z.object({
  projectId: idSchema('projectId'),
  projectUserId: idSchema('projectUserId'),
});

export type ProjectUserRole = z.infer<typeof projectUserRoleSchema>;
export const projectUserRoleSchema = z.union([
  z.literal('distributor'),
  z.literal('admin'),
  z.literal('installer'),
  z.literal('viewer'),
]);

export type CreateProjectUserBody = z.infer<typeof createProjectUserBodySchema>;
export const createProjectUserBodySchema = z.object({
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phoneNr: z.string().optional(),
  companyId: z.number().optional(),
  personalConsumer: z.boolean().optional(),
  companyName: z.string().optional(),
  role: projectUserRoleSchema,
  expiryDate: z.string().optional(),
});

export type ProjectTeamInviteBody = z.infer<typeof projectTeamInviteBodySchema>;
export const projectTeamInviteBodySchema = z.object({
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  phoneNr: z.string().optional(),
  companyId: z.number().optional(),
  personalConsumer: z.boolean().optional(),
  companyName: z.string().optional(),
  role: projectUserRoleSchema,
  expiryDate: z.string().optional(),
  preferredLanguage: preferredLanguageSchema.optional(),
});
export const alertChannelsSchema = z.object({
  email: z.boolean(),
  sms: z.boolean(),
});
